<div class="app-wrapper" [ngClass]="{'has-sidebar': showSidebar}">
  <app-header *ngIf="showHeader" [createBookingList]="notificationService.bookingInfo"
  [vendorBookingList]="notificationService.vendorAssignmentInfo"
  [cabAllocBookingList]="notificationService.cabAssignmentInfo"
  [headerTitle]="headerTitle"></app-header>
  <app-header-notification *ngIf="showNotification" ></app-header-notification>
  <main class="router-content-wrapper">
    <router-outlet></router-outlet>
  </main>
  <app-dialog *ngIf="notification" titleText="Error"  type="alert" [buttonText]="['OK']" (approveCallback)="onDialogConfirm()">
    {{notification}}
  </app-dialog>
  <app-dialog *ngIf="sessionExpirationMsg"  titleText="Session Expired" type="confirm" [buttonText]="['OK']" (approveCallback)="closeDialog()">
    {{sessionExpirationMsg}}
  </app-dialog>
  <app-notification></app-notification>
  <app-sidebar-new *ngIf="showSidebar" [enableCityWiseCreationCutOff]="miscConfig?.enableCityWiseCreationCutOff"></app-sidebar-new>
  <div id="time-picker-popup"></div>
</div>


